export const CRIBL_AGENT_HEADER_NAME = 'X-Cribl-Agent';
export const CRIBL_SOURCE_HEADER_NAME = 'X-Cribl-Source';
export const MAESTRO_AGENT = 'maestro';
export const TYPHON_AGENT = 'typhon';
export const ORG_LEADER_AGENT = 'org-leader';

/**
 * The two headers below deliberately omit the `X-` prefix that `CRIBL_AGENT_HEADER_NAME` and
 * `CRIBL_SOURCE_HEADER_NAME` above still carry. IETF deprecated `X-` for custom application
 * headers (RFC 6648), so new headers are added without it rather than adding to the pile that
 * will eventually need migrating. This follows the `Cribl-App` header in the Leader repo
 * (`src/share/constants.ts`), which was added the same way.
 */

/**
 * Identity of the end user whose request caused an outbound call, so the receiver
 * (e.g. a Leader) can attribute the action to a concrete Auth0 id in its audit and
 * access logs instead of to the shared service account it was authenticated as.
 *
 * Purely informational — never use it for authentication or authorization decisions.
 */
export const CRIBL_USER_ID_HEADER_NAME = 'Cribl-User-Id';

/**
 * Correlation id shared between the caller's logs and the receiver's logs for the
 * same logical request.
 */
export const CRIBL_REQUEST_ID_HEADER_NAME = 'Cribl-Request-Id';

/**
 * API key EventBridge presents (via an API_KEY connection) to authenticate calls to the
 * Zeus scheduled-events dedup endpoint. Compared against process.env.SCHEDULED_EVENTS_API_KEY
 * (Secrets Manager -> External Secrets -> Helm envFromSecret, not deploy-config) by
 * ScheduledEventKeyGuard; missing/mismatched values are rejected with 401.
 * Keep in sync with scheduled_event_key_header in
 * infrastructure/terraform/zeus/zeus-infra/modules/regional/events.tf.
 */
export const CRIBL_SCHEDULED_EVENT_KEY_HEADER_NAME = 'Cribl-Scheduled-Event-Key';
